const config = {
    api: {
        limit: 30
    }
}

export default config;